<template>
	<div>
		<el-row style="margin: 15px 0;">
			<el-button type="primary" size="small" @click='toDetail("")'>添加</el-button>
		</el-row>
		
		<el-table border stripe :data="list" style="width: 100%">
			<el-table-column type="index" width="50"></el-table-column>
			<el-table-column prop="name" label="标题" width="180"></el-table-column>
			<el-table-column prop="desc" label="摘要" width="180"></el-table-column>
			<!-- <el-table-column prop="pic_url" label="封面图" width="300">
				<template slot-scope="scope">
					<el-image :src="scope.row.pic_url" class="pic-preview"></el-image>
				</template>
			</el-table-column> -->
			<el-table-column prop="created_at" label="创建时间" width="200"></el-table-column>
			<el-table-column  label="操作">
				<template slot-scope="scope">
					<el-button type="text" size="small" @click='toDetail(scope.row.id)'>编辑</el-button>
					<el-button type="text" size="small" @click='pinToTop(scope.row.id,scope.row.sort)'>{{scope.row.sort > 0 ? '置顶' : '取消置顶'}}</el-button>
					<el-button type="text" size="small" @click='toCommentList(scope.row.id)'>管理评论</el-button>
					<el-button type="text" size="small" @click="deleteArticle(scope.row.id)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<div style="padding: 15px 0; text-align: right;">
			<el-pagination :hide-on-single-page="true" background @current-change="handleCurrentChange"
				:current-page="pagination.page" :page-size="pagination.page_size"
				layout="total, prev, pager, next, jumper" :total="total">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				pagination: {
					page: 1,
					per_page: 15
				},
				total: 0,
				list: []
			}
		},
		methods: {
			handleCurrentChange(page) {
				this.pagination.page = page;
				this.getList();
			},
			getList() {
				this.$axios.get('announcements', this.pagination).then(res => {
					if(!res.code){
						this.$message.error('列表获取失败')
						return 
					}
					this.list = res.data.data;
					this.pagination.total = res.data.last_page;
				});
			},
			deleteArticle(id) {
				this.$confirm("确定删除?", "提示", {
				  confirmButtonText: "确定",
				  cancelButtonText: "取消",
				  type: "warning"
				}).then(() => {
				    this.$axios.delete("announcement/" + id).then(res => {
				      this.$message({
				        message: res.message,
				        type: "success"
				      });
				      if (res.code == 1) {
				        this.getList();
				      }
				    });
				  })
			},
			pinToTop(id,sort) {
				this.$confirm(sort > 0 ? "将该条置顶?" : '将该条取消置顶?', "提示", {
				  confirmButtonText: "确定",
				  cancelButtonText: "取消",
				  type: "warning"
				}).then(() => {
					let params = {}
					this.list.forEach((item) =>{
						if(item.id != id && !item.sort && sort) {
							params[item.id] = 1
						}
					})
					params[id] = Number(!sort)
				    this.$axios.post("announcement_sort",params).then(res => {
				      this.$message({
				        message: res.message,
				        type: "success"
				      });
				      if (res.code == 1) {
				        this.getList();
				      }
				    });
				  })
			},
			toDetail(id) {
				if(id) {
					this.$router.push({name: '资讯编辑',params: {id}})
				}else{
					this.$router.push({name: '资讯添加'})
				}
			},
			toCommentList(id) {
				this.$router.push({name: '评论列表',params: {id}})
			}
		},
		mounted() {
			this.getList()
		}
	}
</script>

<style scoped lang="scss">
	.pic-preview{
		width: 240px;
		max-height: 240px;
	}
</style>